import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

import { RootState } from 'reducers';
import { publish } from 'services/CentrifugoWS';
import { getChannelName } from 'plugins/customerDisplay/rdx/reducer';
import { ACTIONS } from 'plugins/customerDisplay/constants/actions';

export const handleTipProductDecline = () => async (
  _dispatch: ThunkDispatch<RootState, unknown, Action>,
  getState: () => RootState,
) => {
  const channelName = getChannelName(getState());
  const channel = `customer_display:${channelName}`;

  publish({
    channel,
    message: {
      action: ACTIONS.MISC.DECLINED_TIP,
    },
  });
};
